// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const CANCEL_LINE_ITEM = 'CANCEL_LINE_ITEM';
export const CANCEL_LINE_ITEM_FAILED = 'CANCEL_LINE_ITEM_FAILED';
export const CANCEL_LINE_ITEM_SUCCESS = 'CANCEL_LINE_ITEM_SUCCESS';

export const GET_SERVICE_REQUEST_DATA = 'GET_SERVICE_REQUEST_DATA';
export const GET_BATCH_SERVICE_REQUEST_DATA = 'GET_BATCH_SERVICE_REQUEST_DATA';

export const GET_SERVICE_REQUEST_DATA_SUCCESS = 'GET_SERVICE_REQUEST_DATA_SUCCESS';
export const GET_SERVICE_REQUEST_DATA_FAIL = 'GET_SERVICE_REQUEST_DATA_FAIL';

export const UPDATE_DEVICE_CLAIM = 'UPDATE_DEVICE_CLAIM';

export const UPDATE_ONSITE_ORDER_DETAILS = 'UPDATE_ONSITE_ORDER_DETAILS';

export const {
    cancelLineItem,
    cancelLineItemFailed,
    cancelLineItemSuccess,
    getServiceRequestData,
    getBatchServiceRequestData,
    getServiceRequestDataFail,
    getServiceRequestDataSuccess,
    updateDeviceClaim,
    updateOnsiteOrderDetails,
} = createActions(
    CANCEL_LINE_ITEM,
    CANCEL_LINE_ITEM_FAILED,
    CANCEL_LINE_ITEM_SUCCESS,
    GET_SERVICE_REQUEST_DATA,
    GET_BATCH_SERVICE_REQUEST_DATA,
    GET_SERVICE_REQUEST_DATA_FAIL,
    GET_SERVICE_REQUEST_DATA_SUCCESS,
    UPDATE_DEVICE_CLAIM,
    UPDATE_ONSITE_ORDER_DETAILS
);
